"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags"));

var _loader = _interopRequireDefault(require("./loader.style"));

var _loaderSquare = _interopRequireDefault(require("./loader-square.style"));

var _utils = require("../../style/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

const Loader = ({
  isInsideButton,
  isActive,
  size,
  ...rest
}) => {
  return /*#__PURE__*/_react.default.createElement(_loader.default, _extends({}, rest, (0, _tags.default)("loader", rest)), /*#__PURE__*/_react.default.createElement(_loaderSquare.default, {
    isInsideButton: isInsideButton,
    isActive: isActive,
    size: size
  }), /*#__PURE__*/_react.default.createElement(_loaderSquare.default, {
    isInsideButton: isInsideButton,
    isActive: isActive,
    size: size
  }), /*#__PURE__*/_react.default.createElement(_loaderSquare.default, {
    isInsideButton: isInsideButton,
    isActive: isActive,
    size: size
  }));
};

Loader.defaultProps = {
  size: "medium",
  isInsideButton: false,
  isActive: true
};
Loader.propTypes = { ...marginPropTypes,

  /** Size of the loader. */
  size: _propTypes.default.oneOf(["small", "medium", "large"]),

  /** Applies white color. */
  isInsideButton: _propTypes.default.bool,

  /** Applies slate color. Available only when isInsideButton is true. */
  isActive: _propTypes.default.bool
};
var _default = Loader;
exports.default = _default;